import { useLocale } from "../contexts/LocaleContext";

export function DatenschutzPage() {
  const { t } = useLocale();
  const base = "legal.privacy";

  const renderList = (section: string, count: number) => (
    <ul>
      {Array.from({ length: count }, (_, index) => (
        <li key={`${section}.item${index + 1}`}>{t(`${base}.${section}.item${index + 1}`)}</li>
      ))}
    </ul>
  );

  return (
    <section className="wrapper legal-page privacy-page">
      <h1>{t(`${base}.title`)}</h1>
      <p><strong>{t(`${base}.subtitle`)}</strong></p>
      <p>{t(`${base}.effectiveDate`)}</p>

      <p>{t(`${base}.intro1`)}</p>
      <p>{t(`${base}.intro2`)}</p>

      <h2>{t(`${base}.section1.title`)}</h2>
      <p>{t(`${base}.section1.text1`)}</p>
      <p>
        {t(`${base}.section1.line1`)}<br />
        {t(`${base}.section1.line2`)}<br />
        {t(`${base}.section1.line3`)}<br />
        {t(`${base}.section1.line4`)}<br />
        {t(`${base}.section1.line5`)}<br />
        {t(`${base}.section1.line6`)}
      </p>
      <p>{t(`${base}.section1.text2`)}</p>
      <p>{t(`${base}.section1.line7`)}</p>

      <h2>{t(`${base}.section2.title`)}</h2>
      <p>{t(`${base}.section2.text1`)}</p>
      <p>{t(`${base}.section2.text2`)}</p>

      <h2>{t(`${base}.section3.title`)}</h2>
      <p>{t(`${base}.section3.text1`)}</p>
      {renderList("section3", 15)}

      <h2>{t(`${base}.section4.title`)}</h2>
      <p>{t(`${base}.section4.text1`)}</p>
      {renderList("section4", 14)}

      <h2>{t(`${base}.section5.title`)}</h2>
      <p>{t(`${base}.section5.text1`)}</p>
      {renderList("section5", 4)}
      <p>{t(`${base}.section5.text2`)}</p>

      {Array.from({ length: 6 }, (_, index) => index + 6).map((sectionNumber) => {
        const section = `section${sectionNumber}`;
        return (
          <div key={section}>
            <h2>{t(`${base}.${section}.title`)}</h2>
            <p>{t(`${base}.${section}.text1`)}</p>
            {sectionNumber !== 8 && sectionNumber !== 14 && sectionNumber !== 26 && sectionNumber !== 27 && sectionNumber !== 28 ? (
              <p>{t(`${base}.${section}.text2`)}</p>
            ) : null}
            {sectionNumber === 10 ? <p>{t(`${base}.section10.text3`)}</p> : null}
            {sectionNumber === 11 ? <p>{t(`${base}.section11.text3`)}</p> : null}
          </div>
        );
      })}

      <h2>{t(`${base}.section12.title`)}</h2>
      <p>{t(`${base}.section12.text1`)}</p>
      {renderList("section12", 8)}
      <p>{t(`${base}.section12.text2`)}</p>

      <h2>{t(`${base}.section13.title`)}</h2>
      <p>{t(`${base}.section13.text1`)}</p>
      <p>{t(`${base}.section13.text2`)}</p>

      <h2>{t(`${base}.section14.title`)}</h2>
      <p>{t(`${base}.section14.text1`)}</p>

      <h2>{t(`${base}.section15.title`)}</h2>
      <p>{t(`${base}.section15.text1`)}</p>
      <p>{t(`${base}.section15.text2`)}</p>

      <h2>{t(`${base}.section16.title`)}</h2>
      <p>{t(`${base}.section16.text1`)}</p>
      <p>{t(`${base}.section16.text2`)}</p>

      <h2>{t(`${base}.section17.title`)}</h2>
      <p>{t(`${base}.section17.text1`)}</p>
      <p>{t(`${base}.section17.text2`)}</p>

      <h2>{t(`${base}.section18.title`)}</h2>
      <p>{t(`${base}.section18.text1`)}</p>
      <p>{t(`${base}.section18.text2`)}</p>
      {renderList("section18", 8)}

      <h2>{t(`${base}.section19.title`)}</h2>
      <p>{t(`${base}.section19.text1`)}</p>
      <p>{t(`${base}.section19.text2`)}</p>

      <h2>{t(`${base}.section20.title`)}</h2>
      <p>{t(`${base}.section20.text1`)}</p>
      <p>{t(`${base}.section20.text2`)}</p>

      <h2>{t(`${base}.section21.title`)}</h2>
      <p>{t(`${base}.section21.text1`)}</p>
      <p>{t(`${base}.section21.text2`)}</p>
      {renderList("section21", 7)}

      <h2>{t(`${base}.section22.title`)}</h2>
      <p>{t(`${base}.section22.text1`)}</p>
      {renderList("section22", 8)}

      <h2>{t(`${base}.section23.title`)}</h2>
      <p>{t(`${base}.section23.text1`)}</p>

      <h2>{t(`${base}.section24.title`)}</h2>
      <p>{t(`${base}.section24.text1`)}</p>
      {renderList("section24", 6)}
      <p>{t(`${base}.section24.text2`)}</p>

      <h2>{t(`${base}.section25.title`)}</h2>
      <p>{t(`${base}.section25.text1`)}</p>
      <p>{t(`${base}.section25.text2`)}</p>

      <h2>{t(`${base}.section26.title`)}</h2>
      <p>{t(`${base}.section26.text1`)}</p>

      <h2>{t(`${base}.section27.title`)}</h2>
      <p>{t(`${base}.section27.text1`)}</p>

      <h2>{t(`${base}.section28.title`)}</h2>
      <p>{t(`${base}.section28.text1`)}</p>

      <h2>{t(`${base}.section29.title`)}</h2>
      <p>{t(`${base}.section29.text1`)}</p>
      <p>{t(`${base}.section29.text2`)}</p>

      <h2>{t(`${base}.section30.title`)}</h2>
      <p>{t(`${base}.section30.text1`)}</p>
      <p>
        {t(`${base}.section30.line1`)}<br />
        {t(`${base}.section30.line2`)}<br />
        {t(`${base}.section30.line3`)}<br />
        {t(`${base}.section30.line4`)}<br />
        {t(`${base}.section30.line5`)}<br />
        {t(`${base}.section30.line6`)}
      </p>
    </section>
  );
}
